define('modules/integrations/companySelector/view',['require','exports','module','views/BaseView','helpers/modelHelpers','ldsh!./template'],function (require, exports, module) {
  'use strict';

  var BaseView = require('views/BaseView');
  var modelHelpers = require('helpers/modelHelpers');

  var View = BaseView.extend({
    template: require('ldsh!./template'),
    events: {
      'click .company-selector': 'selectCompany'
    },

    initialize: function () {
        var companies = this.getMyCompanies();        
        var companyId = this.group.get('selectedCompany') || companies[0].id;                       
        this.group.set('selectedCompany', companyId);                                
    },

    serialize: function () {      
      var companyId = this.group.get('selectedCompany');
      var companies = this.getMyCompanies();
      var selectionName = (companyId) ? this.products.getCompanyName(companies, companyId) : this.group.get('name');

      return {
        selectionName: selectionName,
        groupName: this.group.get('name'),
        groupId: this.group.get('id'),
        companyId: companyId,
        companies: companies,
        selectedCompany: this.group.get('selectedCompany')
      };
    },

    getMyCompanies: function () {
      var companies = this.me.isSuperAdmim() ?
          this.group.get('companies') :
          this.products.getMyCompanies();
      return modelHelpers.getCompaniesSorted(companies);
    },

    selectCompany: function (event) {
      var element = event.target;
      var companyId = $(element).data('id');
      this.group.set('selectedCompany', companyId);

      this.render();
      this.serviceToRender(this.me, this.group, this.products);
    }
  });

  module.exports = View;
});

